import type { TFile } from '@modules/files';
import type { TInlineBlock } from '@modules/inlineBlocks';
import type { TItem } from '@modules/items';
import type { TReplica } from '@modules/replicas';

import type { TDocument } from '../types';

const isTDocument = (item: TDocument | TFile | TItem | TReplica | TInlineBlock | undefined): item is TDocument =>
  Boolean(item && (item as TDocument).type === 'DOCUMENT');

export default isTDocument;
